
import { HeadLogo } from "../components/headLogo";
import { CheckpointScrollGp } from "../components/checkpointScrollGp.jsx";

function CheckPointInfoView({ location, onBack, imageKey, infoData }) {
 


  return (
    <div className="checkPointInfo-container">
      <HeadLogo />
      
      <div
        className="checkPointInfo-main-image"
        style={{
          backgroundImage: `url(${imageKey})`,
        }}
      >
         <div
          className="checkPointInfo-continueBtn"
          onClick={onBack}
          id="continueBtn"
        >
          Continue
        </div>
       
      </div>

      <div
        className="checkPointInfo-infoContainer"
        id="infoBox"
      >
        <div className="checkPointInfo-Header">
          <div className="checkPointInfo-stockholm">Stockholm</div>
          <div className="checkPointInfo-title">{location.title}</div>
          <div className="checkPointInfo-info">{location.CheckPointInfo}</div>
          </div>
          <div className="checkPointInfo-vertical-scroll">
            <CheckpointScrollGp
              id={infoData.id}
              modeData={infoData.time}
              mode={"Time"}
            />
            <CheckpointScrollGp
              id={infoData.id}
              modeData={infoData.space}
              mode={"Space"}
            />
          </div>

         
       

      </div>

      
    </div>
  );
}

export { CheckPointInfoView };
